import React from "react";
import PropTypes from "prop-types";
import PersistedMoveGroupTypeInfo from "./PersistedMoveGroupTypeInfo";
import PersistedMoveParentInfo from "./PersistedMoveParentInfo";
import { getPersistedMoveKind } from "./persistedMoveSource";

const PersistedMoveInfo = ({ group, testId }) => {
  const kind = getPersistedMoveKind(group);

  if (kind === "parent") {
    return <PersistedMoveParentInfo group={group} testId={testId} />;
  }

  if (kind === "type") {
    return <PersistedMoveGroupTypeInfo group={group} testId={testId} />;
  }

  return null;
};

PersistedMoveInfo.propTypes = {
  group: PropTypes.object,
  testId: PropTypes.string,
};

export default React.memo(PersistedMoveInfo);
